const PERMISSION_KEY= "community:course";
const PAGE_URL = {
    COURSE_PAGE: "/admin/community/course"
}

export {PERMISSION_KEY, PAGE_URL}

